import { BaseApi } from '@/main/baseApi';

import { DependentTableNames, DMS_MODULE, NAME,	ZAKAZKA_ND, PART_RETURN_REQ_DETAILS } from './constants';

class PartReturnRquestProvider extends BaseApi {
	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case PART_RETURN_REQ_DETAILS:
				return `/${DMS_MODULE}/${PART_RETURN_REQ_DETAILS}/Schema`;
			case ZAKAZKA_ND:
				return `/${DMS_MODULE}/${ZAKAZKA_ND}/Schema`;
			default:
				throw new Error(`schema for ${tableName} is not implemented yet`);
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case PART_RETURN_REQ_DETAILS:
				return `/${DMS_MODULE}/${PART_RETURN_REQ_DETAILS}/`;
			case ZAKAZKA_ND:
				return `/${DMS_MODULE}/${ZAKAZKA_ND}/`;
			default:
				throw new Error(`data for ${tableName} is not implemented yet`);
		}
	}

	async insertData(dto: any) {
		const result = await this.post(`/${DMS_MODULE}/${NAME}/InsertData`, dto);
		return result;
	}

	async insertPartreturnReqDetails(dto: any) {
		const result = await this.post(`/${DMS_MODULE}/${'PartReturnReqDetails'}/InsertData`, dto);
		return result;
	}

	async approveReterurnRequest(dto: any) {
		const result = await this.post(`/${DMS_MODULE}/${'PartReturnReqDetails'}/ApproveReterurnRequest`, dto);
		return result;
	}

	async sendNotification(dto: any) {
		const result = await this.post(`/${DMS_MODULE}/${'PartReturnReqDetails'}/SendNotification`, dto);
		return result;
	}

	async getPartReturnServisReport(filter: {}) {
		return this.fetchPdf(`/${DMS_MODULE}/Reports/GetPartReturnRequestDetails`, filter);
	}
	async CheckPartReturnReqExists(dto:any){
 		const result = await this.post(`/${DMS_MODULE}/${'PartReturnReqDetails'}/CheckPartReturnReqExists`, dto);
 		return result;
	}

	markReportAsPrint(Id:number | null, reportType:string | null) {
		return this.post(`/Servis/Zakazka/MarkAsPrint?id=${Id}&reportType=${reportType}`);
	}
}

export const apiProvider = new PartReturnRquestProvider(DMS_MODULE, NAME);
